export enum QuestionType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  DROPDOWN = 'DROPDOWN',
  FORMULA = 'FORMULA',
  DELIVERABLE = 'DELIVERABLE',
  FEE = 'FEE',
}

export const QuestionTypeIcon = {
  [QuestionType.TEXT]: 'insert_text',
  [QuestionType.DATE]: 'calendar_today',
  [QuestionType.DROPDOWN]: 'checklist',
  [QuestionType.FORMULA]: 'calculate',
  [QuestionType.DELIVERABLE]: 'description',
  [QuestionType.FEE]: 'attach_money',
}

export const QuestionTypeImage = { [QuestionType.NUMBER]: '/assets/icons/insert-number.svg' }
